import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type {
  AddCommentPayload,
  CreateSharedLinkPayload,
  ReportCampaignOption,
  ReportComment,
  ReportTabsData,
  SharedLinkItem,
} from '../types/reports';

export type ApiEnvelope<T> = {
  message?: string;
  success?: boolean;
  data?: T;
};

export async function fetchReportCampaigns() {
  const { data } = await httpClient.get(endpoints.reports.campaignsDropdown);
  return data as ApiEnvelope<ReportCampaignOption[]>;
}

export async function createSharedLink(payload: CreateSharedLinkPayload) {
  const { data } = await httpClient.post(endpoints.reports.generateLink, payload);
  return data as ApiEnvelope<SharedLinkItem>;
}

export async function fetchSharedLinks() {
  const { data } = await httpClient.get(endpoints.reports.list);
  return data as ApiEnvelope<SharedLinkItem[]>;
}

export async function deleteSharedLink(shareId: string) {
  const { data } = await httpClient.delete(endpoints.reports.deleteLink, {
    params: { shareId },
  });
  return data as ApiEnvelope<unknown>;
}

export async function fetchReportTabData(
  token: string,
  activeTab: string,
  params?: {
    page?: number;
    limit?: number;
    date?: string;
    slot?: string;
    screenId?: string;
    [key: string]: unknown;
  },
) {
  const { data } = await httpClient.get(endpoints.reports.publicTab(token, activeTab), {
    params,
  });
  return data as ApiEnvelope<ReportTabsData>;
}

export async function addReportComment(token: string, payload: AddCommentPayload) {
  const { data } = await httpClient.post(endpoints.reports.addComment(token), payload);
  return data as ApiEnvelope<ReportComment>;
}
